"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6104],{

/***/ 43354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cv": function() { return /* binding */ ErrorModal; },
/* harmony export */   "VF": function() { return /* binding */ AlertModal; }
/* harmony export */ });
/* unused harmony export ModalDialogContentText */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26993);
/* harmony import */ var _mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1890);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(68346);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13264);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config_environment__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60031);
/*
 * File: Modal.tsx
 * Project: @inventures/react-lib
 * File Created: Wednesday, 23rd September 2020 4:10:47 pm
 * Author: Esperanza Horn (esperanza@inventures.cl)
 * -----
 * Last Modified: Wednesday, 12th July 2023 6:57:54 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2020 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 










var IconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    position: "relative",
    height: "14px",
    width: "14px",
    marginLeft: "90%",
    marginTop: "20px"
});
var Container = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({});
var DialogTitle = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "17px",
    lineHeight: "150%",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "center",
    marginBottom: "12px"
});
var DialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "150%",
    letterSpacing: "-0.011em",
    textAlign: "center",
    color: "#414046",
    margin: "0px 18px 12px 18px"
});
var DialogActions = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "direction";
    }
})(function(param) {
    var direction = param.direction;
    return {
        display: "flex",
        flexDirection: direction || "column",
        alignItems: "center",
        padding: direction === "row" ? "16px" : "17px 0px",
        gap: direction === "row" ? "16px" : "0px"
    };
});
var ButtonAction = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    borderRadius: "100px",
    height: "42px",
    width: "199px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    textDecoration: "none",
    textTransform: "none"
});
var Pointer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("div")({
    cursor: "pointer"
});
var ModalDialog = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_mui_material_Dialog__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "changeDialogPaper";
    }
})(function(param) {
    var changeDialogPaper = param.changeDialogPaper;
    return {
        "& .MuiDialog-paper": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            margin: 16,
            maxWidth: 336
        }, changeDialogPaper ? {
            width: "100%",
            minHeight: 197
        } : {})
    };
});
var ModalDialogContentText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(DialogContentText, {
    shouldForwardProp: function(prop) {
        return prop !== "alingContentLeft";
    }
})(function(param) {
    var alignContentLeft = param.alignContentLeft;
    return {
        textAlign: alignContentLeft ? "left" : "center",
        whiteSpace: "pre-line"
    };
});
function AlertModal(props) {
    var title = props.title, open = props.open, content = props.content, children = props.children, actions = props.actions, actionsDirection = props.actionsDirection, setOpen = props.setOpen, onClose = props.onClose, disableEscapeKeyDown = props.disableEscapeKeyDown, onBackdropClick = props.onBackdropClick, AlignContentLeft = props.AlignContentLeft, changeDialogPaper = props.changeDialogPaper, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, [
        "title",
        "open",
        "content",
        "children",
        "actions",
        "actionsDirection",
        "setOpen",
        "onClose",
        "disableEscapeKeyDown",
        "onBackdropClick",
        "AlignContentLeft",
        "changeDialogPaper"
    ]);
    var handleClose = function() {
        if (onClose) onClose();
        else if (actions.length === 1) actions[0].onActionClick();
        setOpen(false);
    };
    var haveHandleClose = (actions === null || actions === void 0 ? void 0 : actions.length) === 1 || onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, otherProps), {
        open: open,
        onClose: handleClose,
        changeDialogPaper: changeDialogPaper,
        disableEscapeKeyDown: disableEscapeKeyDown,
        onBackdropClick: onBackdropClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(IconContainer, {
                    children: haveHandleClose && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Pointer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            layout: "fill",
                            src: "/assets/images/home/closeicon.webp",
                            alt: "closeIcon",
                            objectFit: "contain",
                            onClick: handleClose
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogTitle, {
                    children: title
                }),
                content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ModalDialogContentText, {
                    alignContentLeft: AlignContentLeft,
                    children: content
                }),
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DialogActions, {
                    direction: actionsDirection,
                    children: actions === null || actions === void 0 ? void 0 : actions.map(function(action, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonAction, {
                            onClick: action.onActionClick,
                            color: "primary",
                            variant: action.variant,
                            children: action.text
                        }, index);
                    })
                })
            ]
        })
    }));
}
function ErrorModal(props) {
    var open = props.open, title = props.title, description = props.description, handleBack = props.handleBack, whatsappText = props.whatsappText;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AlertModal, {
        title: title,
        open: open,
        setOpen: function() {},
        disableEscapeKeyDown: true,
        disableBackdropClick: true,
        actions: [
            {
                text: "Aceptar",
                onActionClick: handleBack,
                variant: "contained"
            }, 
        ],
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ModalDialogContentText, {
            children: [
                description,
                ", intenta nuevamente o",
                " ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                    target: "_blank",
                    href: "https://api.whatsapp.com/send?phone=".concat(_config_environment__WEBPACK_IMPORTED_MODULE_3__/* .PHONE_NUMBER.CLEAN */ .UE.CLEAN, "&text=").concat(encodeURI(whatsappText)),
                    children: "cont\xe1ctanos para recibir ayuda"
                })
            ]
        })
    });
}


/***/ }),

/***/ 21302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ isLoadFileError; },
  "V": function() { return /* binding */ useUpload; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ../../node_modules/browser-image-compression/dist/browser-image-compression.mjs
var browser_image_compression = __webpack_require__(78321);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(66252);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./src/hooks/useSegment.ts
var useSegment = __webpack_require__(59945);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/upload-prescription/queries/getPrescriptionUploadLink.tsx
/*
 * File: getPrescriptionUploadLink
 * Project: meki
 * File Created: Friday, 25th September 2020 12:47:01 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Monday, 1st February 2021 5:49:52 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query ",
        "($params: GetPrescriptionUploadLinkParams) {\n    getPrescriptionUploadLink(params: $params)\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getPrescriptionUploadLink = function(name) {
    return (0,lib/* gql */.Ps)(_templateObject(), name);
};

// EXTERNAL MODULE: ./src/utils/upload.ts
var upload = __webpack_require__(80301);
;// CONCATENATED MODULE: ./src/queries/prescription/mutations/createPrescription.tsx
/*
 * File: createPrescription.tsx
 * Project: meki
 * File Created: Wednesday, 7th October 2020 12:51:25 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 26th August 2021 4:20:51 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function createPrescription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\nmutation ",
        "($params: CreatePrescriptionParams!){\n    createPrescription(params: $params){\n        id\n        uuid\n        url\n      }\n    }\n"
    ]);
    createPrescription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var createPrescription = function(name) {
    return (0,lib/* gql */.Ps)(createPrescription_templateObject(), name);
};

// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
;// CONCATENATED MODULE: ./src/screens/prescription/hooks/useUpload.ts















var UPLOAD_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/png"
];
var MAX_FILE_SIZE = 1;
var isLoadFileError = function(error) {
    if ([
        "DOCUMENT_SIZE",
        "UNSUPPORTED_FILE"
    ].includes(error)) return true;
    return false;
};
function useUpload() {
    var track = (0,useSegment/* useSegment */.K)().track;
    var ref = (0,react.useState)({}), loadings = ref[0], setLoadings = ref[1];
    var currentId = (0,react.useRef)(0);
    var client = (0,useApolloClient/* useApolloClient */.x)();
    var ref1 = (0,react.useState)(null), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(createPrescription("simple"), {
        update: function update(cache, param) {
            var data = param.data;
            cache.modify({
                id: cache.identify((0,storeUtils/* makeReference */.kQ)("ROOT_QUERY")),
                fields: {
                    pendingPrescriptions: function pendingPrescriptions(prescriptions) {
                        return (0,_to_consumable_array/* default */.Z)(prescriptions).concat([
                            data.createPrescription
                        ]);
                    }
                }
            });
        }
    }), 1), createPrescriptionMutation = ref2[0];
    //Logic
    var compressImage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(file) {
            var options, compressedFile, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        options = {
                            maxSizeMB: 1,
                            useWebWorker: true
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0,browser_image_compression/* default */.Z)(file, options)
                        ];
                    case 2:
                        compressedFile = _state.sent();
                        return [
                            2,
                            compressedFile
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            2,
                            file
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(file) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    var onAskForHelp = (0,react.useCallback)(function(userId) {
        void track("payment error contact", {
            userId: userId,
            error: "Prescription upload error"
        });
        window.open("https://api.whatsapp.com/send?phone=".concat(environment/* PHONE_NUMBER.CLEAN */.UE.CLEAN, "&text=").concat(encodeURI("Hola, tengo problemas para subir la foto de mi receta.")), "_blank");
    }, [
        track
    ]);
    var onError = (0,react.useCallback)(function(code) {
        if (isLoadFileError(code)) {
            if (code === "DOCUMENT_SIZE") {
                void track("prescription upload error", {
                    error: "document size"
                });
                setErrorMessage({
                    title: "No se puede subir el documento",
                    description: "Intenta con un documento m\xe1s liviano."
                });
            }
            if (code === "UNSUPPORTED_FILE") {
                void track("prescription upload error", {
                    error: "unsupported file"
                });
                setErrorMessage({
                    title: "Error en formato",
                    description: "La imagen debe ser en formato jpeg, png o pdf. Intenta nuevamente o cont\xe1ctanos para pedir ayuda."
                });
            }
        } else {
            setErrorMessage({
                title: "Ha ocurrido un error",
                description: "Intenta nuevamente, si el problema persiste cont\xe1ctanos."
            });
        }
    }, [
        track
    ]);
    var handleImageLoader = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(blobFile) {
            var getUploadData, uploadData, uploadFileResponse, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        getUploadData = function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(function(file) {
                                var response;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                client.query({
                                                    query: getPrescriptionUploadLink("uploadPrescriptionScreen"),
                                                    fetchPolicy: "network-only",
                                                    variables: {
                                                        params: {
                                                            format: file.type
                                                        }
                                                    }
                                                })
                                            ];
                                        case 1:
                                            response = _state.sent();
                                            return [
                                                2,
                                                response.data.getPrescriptionUploadLink
                                            ];
                                    }
                                });
                            });
                            return function getUploadData(file) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        return [
                            4,
                            getUploadData(blobFile)
                        ];
                    case 2:
                        uploadData = _state.sent();
                        return [
                            4,
                            (0,upload/* uploadFile */.c)(blobFile, uploadData)
                        ];
                    case 3:
                        uploadFileResponse = _state.sent();
                        return [
                            4,
                            createPrescriptionMutation({
                                variables: {
                                    params: {
                                        url: uploadFileResponse
                                    }
                                }
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        onError(error);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function(blobFile) {
            return _ref.apply(this, arguments);
        };
    }(), [
        client,
        createPrescriptionMutation,
        onError
    ]);
    var loadFile = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event, setError) {
            var divisor, file, sizeIsPermitted, isImage, finalFile;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        divisor = 1024 * 1024;
                        file = event.target.files[0];
                        if (!file) {
                            return [
                                2
                            ];
                        }
                        if (!(file && UPLOAD_TYPES.includes(file.type))) return [
                            3,
                            4
                        ];
                        setLoadings((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loadings), (0,_define_property/* default */.Z)({}, currentId.current, true)));
                        sizeIsPermitted = file.size / divisor <= MAX_FILE_SIZE;
                        isImage = file.type === "image/jpeg" || file.type === "image/png";
                        if (!sizeIsPermitted && !isImage) {
                            onError("DOCUMENT_SIZE");
                            setLoadings(function(prevState) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, currentId.current, false));
                            });
                            return [
                                2
                            ];
                        }
                        finalFile = file;
                        if (!isImage) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            compressImage(file)
                        ];
                    case 1:
                        finalFile = _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            4,
                            handleImageLoader(finalFile)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        onError("UNSUPPORTED_FILE");
                        _state.label = 5;
                    case 5:
                        setLoadings(function(prevState) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), (0,_define_property/* default */.Z)({}, currentId.current, false));
                        });
                        currentId.current = currentId.current + 1;
                        setError(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(event, setError) {
            return _ref.apply(this, arguments);
        };
    }(), [
        loadings,
        handleImageLoader,
        onError,
        compressImage
    ]);
    return {
        loadings: loadings,
        loadFile: loadFile,
        onAskForHelp: onAskForHelp,
        onError: onError,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage
    };
}


/***/ }),

/***/ 80301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ uploadFile; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45680);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89644);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/*
 * File: upload.ts
 * Project: meki
 * File Created: Thursday, 5th November 2020 4:06:15 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Tuesday, 12th October 2021 10:10:53 am
 * Modified By: Luis Aparicio (luis@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 


function uploadFile(file, uploadData, config) {
    return _uploadFile.apply(this, arguments);
}
function _uploadFile() {
    _uploadFile = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(file, uploadData, config) {
        var url, key, policy, successActionStatus, xAmzAlgorithm, xAmzCredential, xAmzDate, xAmzSignature, formData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    url = uploadData.url, key = uploadData.key, policy = uploadData.policy, successActionStatus = uploadData.successActionStatus, xAmzAlgorithm = uploadData.xAmzAlgorithm, xAmzCredential = uploadData.xAmzCredential, xAmzDate = uploadData.xAmzDate, xAmzSignature = uploadData.xAmzSignature;
                    formData = new FormData();
                    formData.append("Content-Type", file.type);
                    formData.append("key", key);
                    formData.append("policy", policy);
                    formData.append("success_action_status", successActionStatus);
                    formData.append("x-amz-algorithm", xAmzAlgorithm);
                    formData.append("x-amz-credential", xAmzCredential);
                    formData.append("x-amz-date", xAmzDate);
                    formData.append("x-amz-signature", xAmzSignature);
                    formData.append("file", new File([
                        file
                    ], key.split("/").slice(-1).join(""), {
                        type: file.type
                    }));
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_0___default().request({
                            url: "".concat(url),
                            method: "POST",
                            data: formData,
                            headers: {
                                Accept: "application/json",
                                "Content-Type": file.type
                            },
                            onUploadProgress: function(progressEvent) {
                                var ref;
                                var percentCompleted = Math.round(progressEvent.loaded * 100 / progressEvent.total);
                                config === null || config === void 0 ? void 0 : (ref = config.onUploadProgress) === null || ref === void 0 ? void 0 : ref.call(config, percentCompleted);
                            }
                        })
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        key
                    ];
            }
        });
    });
    return _uploadFile.apply(this, arguments);
}


/***/ })

}]);